/**
 * @doc Editor
 */
export var PremiumIntent;
(function (PremiumIntent) {
    PremiumIntent["Neutral"] = "NEUTRAL";
    PremiumIntent["Free"] = "FREE";
    PremiumIntent["Paid"] = "PAID";
})(PremiumIntent || (PremiumIntent = {}));
//# sourceMappingURL=premiumIntent.js.map